var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"admin-main-main"},[_c('div',{staticClass:"admin-main-container"},[_c('pro-nav'),_c('div',{staticClass:"content"},[_c('admin-nav',{staticClass:"admin-nav"}),_c('router-view',{staticClass:"router-view"})],1)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }